import { useFeatureFlagStatus } from '@/hooks/use-feature-flag';
import { Box, Flex } from '@chakra-ui/react';
import { FeatureFlag } from '@fluenceur/types';
import { ShortLogo } from '@fluenceur/ui';
import React from 'react';
import { CompanionTrigger } from '../../companion/feed/CompanionTrigger';
import { CompanionPanelTrigger } from '../../companion/panel/CompanionPanelTrigger';
import { FeatureAnnouncementIndicator } from '../../announcements/FeatureAnnouncementIndicator';
import NotificationBell from '../nav-bar/NotificationBell';
import UserMenu from '../nav-bar/UserMenu';
import { useIsMobileLayout } from './nav-dark';

interface TopBarProps {
  top?: number | string;
  actions?: React.ReactNode;
}

export const TOP_BAR_HEIGHT = 56;
export const TOP_BAR_HEIGHT_CSS = `${TOP_BAR_HEIGHT}px`;

/**
 * One companion trigger at a time: the conversational panel's for its cohort,
 * the feed's for everyone else, and neither until the flag is known, so the
 * wrong one never flashes first.
 */
const CompanionTriggerSlot = () => {
  const { enabled, isLoading } = useFeatureFlagStatus(FeatureFlag.COMPANION_PANEL);
  if (isLoading) return null;
  return enabled ? <CompanionPanelTrigger /> : <CompanionTrigger />;
};

const TopBar: React.FC<TopBarProps> = ({ top = 0, actions }) => {
  const isMobile = useIsMobileLayout();

  return (
    <Box
      as="header"
      position="fixed"
      top={top}
      left={0}
      right={0}
      zIndex="1200"
      h={TOP_BAR_HEIGHT_CSS}
    >
      {/* Transparent: it sits on the frame NavFrameBackdrop paints. */}
      <Flex align="center" justify="space-between" h="100%" px={4}>
        {/* Logo */}
        <Box>
          <ShortLogo height="24px" color="white" />
        </Box>

        <Flex align="center" gap={2}>
          {actions === undefined ? (
            <>
              <CompanionTriggerSlot />
              <FeatureAnnouncementIndicator />
              <NotificationBell />
              {!isMobile && <UserMenu />}
            </>
          ) : (
            actions
          )}
        </Flex>
      </Flex>
    </Box>
  );
};

export default TopBar;
